import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

const STEPS = [
  { n: 1, label: "Type" },
  { n: 2, label: "Locations" },
  { n: 3, label: "Items" },
  { n: 4, label: "Date & Contact" },
  { n: 5, label: "Confirm" },
];

export default function ProgressStepper({ current }) {
  return (
    <div className="w-full" data-testid="booking-stepper">
      <div className="flex items-center gap-2 sm:gap-3">
        {STEPS.map((s, i) => {
          const done = current > s.n;
          const active = current === s.n;
          return (
            <div key={s.n} className="flex-1 flex items-center gap-2 sm:gap-3">
              <div className="flex flex-col items-center gap-1.5 flex-shrink-0">
                <div
                  className={cn(
                    "w-8 h-8 sm:w-9 sm:h-9 rounded-full grid place-items-center text-xs sm:text-sm font-bold transition-all",
                    done && "bg-[#081537] text-white",
                    active && "bg-[#081537] text-white ring-4 ring-[#081537]/15",
                    !done && !active && "bg-slate-100 text-slate-400"
                  )}
                >
                  {done ? <Check className="w-4 h-4" /> : s.n}
                </div>
                <div className={cn("text-[10px] sm:text-xs font-semibold whitespace-nowrap", active || done ? "text-[#081537]" : "text-slate-400")}>{s.label}</div>
              </div>
              {i < STEPS.length - 1 && (
                <div className={cn("flex-1 h-0.5 rounded-full transition-all -mt-5", current > s.n ? "bg-[#081537]" : "bg-slate-200")} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
